"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Patch } from "@/shared/libs/axios/request";
import { itemKeys } from "@/entities/item";
import type { ItemResponse, UpdateItemRequest } from "@stocks/shared";

/** silent: 다른 흐름(등록 후 대표 사진 지정 등)의 일부일 때 성공 토스트를 생략 */
export const useUpdateItem = (options?: { silent?: boolean }) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, values }: { id: string; values: UpdateItemRequest }) =>
      Patch<ItemResponse, UpdateItemRequest>(`/v1/items/${id}`, values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: itemKeys.all });
      if (!options?.silent) toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "품목 수정에 실패했습니다."),
  });
};
